import SVG, { EL, SVGGROUP, SVGPATH, SVGSHAPE } from '../../DOM/svg/SVG.js';
import DIV from '../../DOM/div/DIV.js';
import { SPAN } from '../../DOM/a/anchor/ANCHOR.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { span } from '../../DOM/span/SPAN.js';
// Model Structure
export const iconAttr = makeAttrStruct([]);
export const iconData = makeDataStruct([
    ['svg'],
    ['text', ''],
    ['anchor', null]
]);
export const iconModel = makeStruct([
    ['attributes', iconAttr],
    ['data', iconData]
]);
// Simplified Model
export function icon(svg, text, anchor) {
    return {
        attributes: iconAttr(),
        data: iconData(svg, text, anchor)
    };
}
/** Creates a scaleable vector graphic within a wrapper */
export default class ICON extends DIV {
    svg;
    constructor(node, model) {
        super(node, model);
        this.addClass('icon');
        this.svg = new SVG(this, model.data.svg);
        this.text = new SPAN(this, span(model.data.text));
    }
}
export { EL, SVG, SVGGROUP, SVGPATH, SVGSHAPE };
